import Layout from '@/libs/components/Layout'
import { getUrlParam } from '@/libs/functions/getValue'
import styles from './index.scss'

export default function LimousineOrderResult() {
  const status = getUrlParam('status')
  const isSuccess = status === 'success'
  const resultText = isSuccess ? '支付成功' : '支付失败'

  return (
    <Layout title="龙腾出行礼宾车支付">
      <div className={styles.page}>
        <div className={styles.resultPanel}>
          <div
            className={`${styles.icon} ${
              isSuccess ? styles.successIcon : styles.failIcon
            }`}
          >
            {isSuccess ? '✓' : '×'}
          </div>
          <div className={styles.resultText}>{resultText}</div>
        </div>
      </div>
    </Layout>
  )
}
